import { render, staticRenderFns } from "./cmpbaixartitulospagar.vue?vue&type=template&id=5ec0ae54&"
import script from "./cmpbaixartitulospagar.vue?vue&type=script&lang=js&"
export * from "./cmpbaixartitulospagar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports